import { Button } from '@mui/material'
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react'
import { MagicSpinner } from 'react-spinners-kit'
import Image from 'next/image'
import classNames from 'classnames'

interface Prop {
  onClick?: () => void
  loading?: boolean
  fullwidth?: boolean
  disabled?: boolean
  size?: 'sm' | 'lg'
  type?: 'contained' | 'soft' | 'outlined' | 'text' | 'shop'
  leadingIconImg?: string
  leadingIcon?: ReactNode
  trailingIconImg?: string
  trailingIcon?: ReactNode
  selected?: boolean
  classNames?: string
}

const MCButton: FunctionComponent<PropsWithChildren<Prop>> = (props) => {
  const style: ButtonStyle = getStyle(props.type ?? 'contained', props.selected)
  return (
    <Button
      id='mobibtn'
      type='submit'
      onClick={props.disabled === true ? () => { } : props.onClick}
      disabled={props.disabled}
      classes={{ disabled: style.disabled }}
      className={classNames(props.fullwidth !== true ? 'w-fit' : 'w-full', props.size === 'sm' ? 'h-10' : 'h-12', style.main, props.classNames)}
    >
      {
        props.loading === true
          ? <MagicSpinner size={30} color={style.loader} loading />
          : (
            <div className='flex flex-row items-center justify-between'>
              {props.leadingIcon === undefined && props.leadingIconImg !== undefined ? <Image width={30} height={30} alt='img' src={props.leadingIconImg ?? ''} className={props.size === 'sm' ? 'w-5 h-5' : 'w-[22px], h-[22px]'} /> : props.leadingIcon !== undefined && props.leadingIconImg === undefined ? props.leadingIcon : ''}
              <p className='mx-2 text-sm font-semibold'>{props.children}</p>
              {props.trailingIcon === undefined && props.trailingIconImg !== undefined ? <Image width={30} height={30} alt='img' src={props.trailingIconImg ?? ''} className={props.size === 'sm' ? 'w-5 h-5' : 'w-[22px], h-[22px]'} /> : props.trailingIcon !== undefined && props.trailingIconImg === undefined ? props.trailingIcon : ''}
            </div>
          )
      }

    </Button>
  )
}
interface ButtonStyle {
  disabled: string
  main: string
  loader: string
}
const getStyle = (type: string, selected?: boolean): ButtonStyle => {
  switch (type) {
    case 'soft':
      return { main: 'rounded-xl normal-case bg-[#FBD0D0] hover:bg-[#FDC4C4] active:bg-[#FDAAAA] focus:bg-[#FCABAB] text-textHigh font-semibold', disabled: 'bg-[#231F1F]/10 text-[#B0B0B0]', loader: '#262626' }
    case 'outlined':
      return { main: 'rounded-xl normal-case border border-solid border-primaryMain bg-surfaceInverse hover:bg-primaryHighStroke active:bg-primaryHighStroke focus:bg-[#FDB5B5] text-textHigh font-semibold', disabled: 'border-primaryHighStroke text-[#B0B0B0]', loader: '#262626' }
    case 'text':
      return { main: 'rounded-xl normal-case bg-transparent hover:bg-primaryHighStroke active:bg-[#FEB4B4] focus:bg-[#FDB5B5] text-textHigh font-semibold', disabled: 'bg-transparent text-[#B0B0B0]', loader: '#262626' }
    case 'shop':
      return { main: classNames('rounded-xl normal-case border border-solid border-[#E5E5E5] shadow bg-surfaceInverse hover:border-[#EF4444] active:border-[#EF4444] focus:border-[#EF4444] text-textHigh', selected === true ? 'border-[#EF4444]' : ''), disabled: 'opacity-50 shadow-none', loader: '#B0B0B0' }
    default:
      return { main: 'rounded-xl normal-case bg-primaryMain hover:bg-primaryMain active:bg-[#B91C1C] focus:bg-[#991B1B] text-textInverse font-semibold', disabled: 'bg-[#EF4444]/20 text-[#B0B0B0]', loader: '#fff' }
  }
}

export default MCButton
